import { useState } from 'react';

// material-ui
import Alert from '@mui/material/Alert';
import Chip from '@mui/material/Chip';
import Dialog from '@mui/material/Dialog';
import DialogContent from '@mui/material/DialogContent';
import DialogTitle from '@mui/material/DialogTitle';
import List from '@mui/material/List';
import ListItemButton from '@mui/material/ListItemButton';
import ListItemText from '@mui/material/ListItemText';

// assets
import BankOutlined from '@ant-design/icons/BankOutlined';
import CheckOutlined from '@ant-design/icons/CheckOutlined';

// project imports
import axios from 'utils/axios';
import useAuth from 'hooks/useAuth';
import { AKTIF_SITE_KEY, SITELER_KEY } from 'utils/authStorage';

// ==============================|| HEADER - SİTE ADI / SİTE DEĞİŞTİR ||============================== //
// DaireDegistir ile aynı desen: çoklu siteli kullanıcı için header'dan erişilen,
// login-time site seçiminin login SONRASI tekrarı (bkz. JWTContext.login() içindeki
// SITELER_KEY kaydı). Tek siteli kullanıcı için sadece salt-okunur bir isim etiketi.

export default function SiteDegistir() {
  const { aktifSite } = useAuth();
  const [open, setOpen] = useState(false);
  const [error, setError] = useState(null);

  if (!aktifSite) return null;

  let siteler = [];
  try {
    siteler = JSON.parse(localStorage.getItem(SITELER_KEY) || '[]');
  } catch {
    siteler = [];
  }

  const coklu = siteler.length > 1;

  const handleSelect = async (site) => {
    if (site.id === aktifSite.id) {
      setOpen(false);
      return;
    }
    setError(null);
    try {
      await axios.post('auth/aktif-site/', { site_id: site.id });
      localStorage.setItem(AKTIF_SITE_KEY, JSON.stringify(site));
      setOpen(false);
      // Query cache'lerin (eski sitenin verisi) sıfırlanması için — DaireDegistir'deki
      // window.location.reload() ile aynı gerekçe (tenant izolasyonu UI'da korunsun).
      window.location.reload();
    } catch {
      setError('Site seçimi sırasında bir hata oluştu, lütfen tekrar deneyin.');
    }
  };

  return (
    <>
      <Chip
        icon={<BankOutlined style={{ fontSize: 14 }} />}
        label={aktifSite.ad}
        onClick={coklu ? () => setOpen(true) : undefined}
        variant="outlined"
        sx={{
          fontWeight: 500,
          bgcolor: coklu ? 'primary.lighter' : 'grey.100',
          color: coklu ? 'primary.dark' : 'text.primary',
          borderColor: coklu ? 'primary.light' : 'divider',
          '& .MuiChip-icon': { color: coklu ? 'primary.dark' : 'text.secondary' }
        }}
      />
      {coklu && (
        <Dialog open={open} onClose={() => setOpen(false)} maxWidth="xs" fullWidth>
          <DialogTitle>Site Değiştir</DialogTitle>
          <DialogContent>
            {error && <Alert severity="error">{error}</Alert>}
            <List disablePadding>
              {siteler.map((site) => {
                const aktifMi = site.id === aktifSite.id;
                return (
                  <ListItemButton key={site.id} divider selected={aktifMi} onClick={() => handleSelect(site)}>
                    <ListItemText primary={site.ad} secondary={aktifMi ? 'Şu an aktif' : null} />
                    {aktifMi && <CheckOutlined />}
                  </ListItemButton>
                );
              })}
            </List>
          </DialogContent>
        </Dialog>
      )}
    </>
  );
}
